import { svg } from "lit";
const icon = svg `<path d="M10.9251 13.9246L16.2443 8.63042L15.1751 7.56122L10.9251 11.8112L8.80012 9.68622L7.74629 10.74L10.9251 13.9246ZM1.38477 20.2304V18.7304H22.6155V20.2304H1.38477ZM2.50012 17.7304V3.73047H21.5001V17.7304H2.50012ZM4.00012 16.2304H20.0001V5.23042H4.00012V16.2304Z" fill="currentColor"/>`;
export default icon;
